var map = {
	"./add-circle.svg": "./src/icons/svg/add-circle.svg",
	"./add.svg": "./src/icons/svg/add.svg",
	"./backtop.svg": "./src/icons/svg/backtop.svg",
	"./copy.svg": "./src/icons/svg/copy.svg",
	"./good.svg": "./src/icons/svg/good.svg",
	"./minus-circle.svg": "./src/icons/svg/minus-circle.svg",
	"./minus.svg": "./src/icons/svg/minus.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./save.svg": "./src/icons/svg/save.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./share.svg": "./src/icons/svg/share.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";